import { render, staticRenderFns } from "./AppearanceColorFilter.vue?vue&type=template&id=d2b1e94a&scoped=true&"
import script from "./AppearanceColorFilter.vue?vue&type=script&lang=js&"
export * from "./AppearanceColorFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b1e94a",
  null
  
)

export default component.exports